// @todo: Migrate to 'Toast' from @wandb/components. For more details see:
// https://wandb.github.io/components/?path=/docs/migration-guide--docs
// eslint-disable-next-line wandb/no-deprecated-imports
import {toast} from '@wandb/weave/common/components/elements/Toast';
// @todo: Migrate to @wandb/components. For more details see:
// https://wandb.github.io/components/?path=/docs/migration-guide--docs
// eslint-disable-next-line wandb/no-deprecated-imports
import {Button} from '@wandb/weave/components';
import {Tailwind} from '@wandb/weave/components/Tailwind';
import {clsx} from 'clsx';
import copyToClipboard from 'copy-to-clipboard';
import React, {useState} from 'react';
import {GenericWebhook} from 'src/components/Webhooks/WebhooksTable';

// Format the help snippet based on whether the webhook uses secrets or not
function getWebhookRequestCurl(
  webhook: GenericWebhook,
  requestPayloadString: string
): string {
  return `#!/bin/bash ${
    webhook.accessTokenRef != null || webhook.secretRef != null
      ? '\n# Your access token and/or secret'
      : ''
  } ${
    webhook.accessTokenRef != null
      ? `\nACCESS_TOKEN="<value of secret ${webhook.accessTokenRef}>"`
      : ''
  } ${
    webhook.secretRef != null
      ? `\nSECRET="<value of secret ${webhook.secretRef}>"`
      : ''
  }

# The data you want to send
PAYLOAD='${requestPayloadString}'
${
  webhook.secretRef != null
    ? `\n# Generate the HMAC signature
# For security, Wandb includes the X-Wandb-Signature in the header computed
# from the payload and the shared secret key associated with the webhook
# using the HMAC with SHA-256 algorithm.
SIGNATURE=$(echo -n "$PAYLOAD" | openssl dgst -sha256 -hmac "$SECRET" -binary | base64)\n`
    : ''
}
# Make the cURL request
curl -X POST \\
  -H "Content-Type: application/json" \\ ${
    webhook.accessTokenRef != null
      ? '\n  -H "Authorization: Bearer $ACCESS_TOKEN" \\'
      : ''
  } ${
    webhook.secretRef != null ? '\n  -H "X-Wandb-Signature: $SIGNATURE" \\' : ''
  }
  -d "$PAYLOAD" \\
  ${webhook.urlEndpoint}
`;
}

type HelpWebhookAutomationProps = {
  webhook: GenericWebhook;
  requestPayload: string;
};
export const HelpWebhookAutomation = ({
  webhook,
  requestPayload,
}: HelpWebhookAutomationProps) => {
  const [isExpanded, setIsExpanded] = useState(false);
  const onToggleExpanded = () => {
    setIsExpanded(!isExpanded);
  };

  const onCopyClick = (e: React.MouseEvent) => {
    e.stopPropagation();
    copyToClipboard(getWebhookRequestCurl(webhook, requestPayload));
    toast('Copied to clipboard');
  };
  return (
    <Tailwind style={{width: '100%'}}>
      <div className="mt-24 w-full text-left text-base">
        To test the webhook request, simply copy the curl command below and
        paste it into your terminal. You can modify the command to include your
        specific data and endpoint details as needed.
      </div>
      <div className="mt-24 flex flex-col justify-center rounded bg-moon-200 p-1">
        <div
          className={clsx(
            `${isExpanded ? 'rounded-t' : 'rounded'}`,
            'min-h-44 cursor-pointer bg-white p-8 hover:bg-moon-50'
          )}
          onClick={onToggleExpanded}>
          <div className="flex flex-row items-center text-sm font-semibold">
            <Button
              variant="ghost"
              size="small"
              icon={isExpanded ? 'chevron-down' : 'chevron-next'}
              onClick={onToggleExpanded}
              className="mr-8"
            />
            Curl command format
            <div className="ml-auto">
              <Button
                variant="secondary"
                size="small"
                startIcon="copy"
                onClick={onCopyClick}>
                Copy
              </Button>
            </div>
          </div>
          {isExpanded && (
            <div className="flex-auto whitespace-pre-wrap p-8 font-['Source_Code_Pro'] text-xs leading-4">
              {getWebhookRequestCurl(webhook, requestPayload)}
            </div>
          )}
        </div>
      </div>
    </Tailwind>
  );
};
